jQuery(document).ready( function(e) {
	// apertura della lightbox
	$(document).delegate('*[data-toggle="lightbox"]', 'click', function(event) {
		event.preventDefault();
		$(this).ekkoLightbox();
	});

	// info versione browser
	var doc = document.documentElement;
	doc.setAttribute('data-useragent', navigator.userAgent);

	// fix altezza del loader
	var altezza_loader = $(window).height();
	$("#loader").css("max-height", altezza_loader)

	// forzo la visualizzazione portrait
	/*detectPortrait();
	$(window).resize(function() {
		detectPortrait("body");
	});*/

	$(window).scroll(function() {
		$('.col-title').each(function( index ) {
			if($(this).visible()){
				$(this).css("visibility","visible");
			}
		});


		// visualizzo titolo collezione
		// intercetto scroll della pagina 
		// controllo se ci sono elementi non visibili
		display_famiglia = $('.fam-box-view').not('.vis-viewport, .vis-partial').first();	
		$(display_famiglia).fadeIn(400);	
		if($(display_famiglia).visible()){
			display_famiglie = $('.fam-box-view').not('.vis-viewport, .vis-partial').slice(0,10);
			$(display_famiglie).each(function(index) {
				var fam_obj = $(this)
				aggiorna_vista(fam_obj, true);	
			});
		}

	})

	$('.navbar-toggle.collapsed').click(function(e){
		if ( $("body.noscroll").length ) {
			$("body.noscroll").removeClass('noscroll');
		} else {
			$("body").addClass('noscroll');
		}
	});

	// Probabilmente da rimuovere.
	$("#loader").fadeOut(800, function() {});	

	$(window).load(function() {
		window.scrollTo(0,0);

		var h_fix = $(window).height() - 70;
		$("#bs-example-navbar-collapse-1").css("max-height", h_fix);
		
		$("img.lazy").lazy({ 
			delay		: 500, 
			visibleOnly : true, 
			effect 		: "fadeIn",
			effectTime 	: 400,
			beforeLoad	: function(element) {element.removeClass("lazy"); }
		});
		$("img.lazy-fast").lazy({ 
			visibleOnly : true, 
			beforeLoad	: function(element) {element.removeClass("lazy-fast"); }
		});

		if ($('div.products-list').length) {
			$('.col-title').first().css("visibility","visible");
			//controllo se ci sono filtri attivi		
			var call = "/filtri/getall";
			var data_temp = "";		
			var fltr = $.get(call, function() { })
			.done(function(data) {
				//console.log(data);
				if(data.length){
					update_fltr_estrusione_2();
				} else {
					$("#loader").fadeOut(800, function() {});
				}
			})
			.fail(function() {
				$("#loader").fadeOut(800, function() {});
			});
		} else {
			$("#loader").fadeOut(800, function() {});			
		}

		// aggiungo l'info sulle grandezze dell'immagini
		// ---------------------------------------------
		/* $(".con-immagini img").each(function( index ) {
			$(this).attr("width",$(this).width());
			$(this).attr("height",$(this).height());
		});	*/

		// Aggiusto la larghezza dell'input di ricerca
		// -------------------------------------------

		if ($('input[type="search"]').length) {
			$('input[type="search"]').attr('size', $('input[type="search"]').val().length);
		}
	});

	if ($('input[type="search"]').length) {
		// sistemo la larghezza dell'input di ricerca
		$('input[type="search"]').keypress(function(e) {
			if(e.which != 13) {
			if($(this).attr('size') < 30 || $(this).val().length < 30 )
				$(this).attr('size', $(this).val().length);
			}
		});
	}

	// disattivo filtri non presenti nella pagina collezione
	if ($('div.products-list.single-collection').length) {
		update_fltr_btn_collection();
	}

	// visualizzazione elementi dinamico in base allo scroll
	// -----------------------------------------------------
	// controllo che non ci siano elementi troppo altri
	// altezza massimo degli elementi di testo 
	var max_height = Math.max.apply(null, $("div.con-testo.mod-text").map(function (){ 
		return $(this).height();
	}).get());
	//console.log("max_height " + max_height);
	if(max_height <= 500){
		window.sr = new scrollReveal();
	}



	// apertura/chiusura filtri
	jQuery('#toggle-filter').click( function(e) {
		e.preventDefault();
		if (jQuery(this).hasClass("cls")) {
			var testo = "Nascondi filtri <b>caratteristiche</b>";	

			jQuery(this).removeClass("cls");
			jQuery(this).addClass("opn");
			
			jQuery(".advanced-filters").removeClass("cls")
			jQuery(".advanced-filters").addClass("opn")

			// cambio testo
			jQuery("#toggle-filter").html(testo);
		} else {
			var testo = "Mostra filtri <b>caratteristiche</b>";

			jQuery(this).removeClass("opn");
			jQuery(this).addClass("cls");
			
			jQuery(".advanced-filters").removeClass("opn");
			jQuery(".advanced-filters").addClass("cls");

			// cambio testo
			jQuery("#toggle-filter").html(testo);
		}
	});

	// effetto over per l'immagine passando sul testo
	jQuery('div.carousel-caption').not(".no-eff").mouseover(function () {
		jQuery(this).parent(".item").addClass('zoom-eff');
	}).mouseout(function() {
		jQuery(this).parent(".item").removeClass('zoom-eff');
	});

	// gestione classe 	
	var isMobile = false; //initiate as false
	// device detection
	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
		|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;
	
	if(!isMobile) {
		jQuery(window).scroll(function () {
			var scrollh = $(this).scrollTop();
			if (scrollh <= 300 ) {
				jQuery(".navbar-fixed-top").removeClass("on-scroll");
				jQuery('body').removeClass("no-padding");
			} else {
				jQuery(".navbar-fixed-top").addClass("on-scroll");
				jQuery('body').addClass("no-padding");
			}
		});
	}

	// attivazione di un filtro
	$('.fltr-btn a').on('click', function(event) {	
		event.preventDefault();

		var current_obj = $(this);

		//attivo il loading
		$("#loader").delay(400).fadeIn(400, function() {
			var filtra = false;

			//console.log($(this));
			var resource = "";

			// controllo se il filtro è attivo
			if($(current_obj).hasClass("active")){
				// disattivo filtro
				resource = $(current_obj).data("resource");
				resource = resource.replace("filtri/","filtri/reset/");
			} else {
				resource = $(current_obj).data("resource");
			}

			$.ajax({
				url: '/' + resource,
				contentType: "application/json",
				dataType:'text',
				async: false,
				type: 'get',
				success:function(data){
					filtra = true;
				}
			});

			if(filtra){
				if($(current_obj).hasClass("active")){
					$(current_obj).removeClass("active");
				} else {
					$(current_obj).addClass("active");
				}
				update_fltr_estrusione_2();
			}
		});		
	});

	// se presente uno slider a full screen modificare la velocità di scroll
	if ($('div.container-fluid').length) {
		var box_scroll = $('[data-scroll-speed]'),
		$window = $(window);
		$window.on('scroll', function(){
			var scrollTop = $window.scrollTop();
			box_scroll.each(function(){
			var $this = $(this),
				scrollspeed = parseInt($this.data('scroll-speed')),
				valore = - scrollTop / scrollspeed;
				if(valore > 30){
					$('.scroll-wrapper-bg-full').addClass("shadow-add"); 
				} else {
					$('.scroll-wrapper-bg-full').removeClass("shadow-add"); 
				}
				$this.css('transform', 'translateY(' + valore + 'px)');
			});
		}); 
	};

	// orologio nella pagina 404
	if ($('#clock').length) {
		setInterval( function() {
		var seconds = new Date().getSeconds();
		var sdegree = seconds * 6;
		var srotate = "rotate(" + sdegree + "deg)";
		$("#sec").css({"-moz-transform" : srotate, "-webkit-transform" : srotate});

		}, 1000 );

		setInterval( function() {
		var hours = new Date().getHours();
		var mins = new Date().getMinutes();
		var hdegree = hours * 30 + (mins / 2);
		var hrotate = "rotate(" + hdegree + "deg)";

		$("#hour").css({"-moz-transform" : hrotate, "-webkit-transform" : hrotate});

		}, 1000 );

		setInterval( function() {
		var mins = new Date().getMinutes();
		var mdegree = mins * 6;
		var mrotate = "rotate(" + mdegree + "deg)";
		$("#min").css({"-moz-transform" : mrotate, "-webkit-transform" : mrotate});

		}, 1000 );
	};

	// fix svg 
	if ($('img.svg').length) {
		jQuery('img.svg').each(function(){
			var $img = jQuery(this);
			var imgID = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL = $img.attr('src');

			jQuery.get(imgURL, function(data) {
				// Get the SVG tag, ignore the rest
				var $svg = jQuery(data).find('svg');

				// Add replaced image's ID to the new SVG
				if(typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if(typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass+' replaced-svg');
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');

				// Replace image with new SVG
				$img.replaceWith($svg);

			}, 'xml');

		});
	}


	// paginazione tabelle
	if ($('.table.clienti-table').length) {
		var table_props = {
			col_0: "none",
			col_1: "none",
			col_2: "none",
			col_3: "none",
			col_4: "none",
			display_all_text: " [ Tutti ] ",
			sort_select: false,
			sort: false,
			paging: true,
			paging_length: 15,
			rows_counter: false,
			rows_counter_text: "Righe:",
			btn_reset: false,
			sort_config: { sort_types: ['String', 'String'] }                        
		};
		var tf = setFilterGrid("tabledinamic", table_props);
		// riposizono tasti navigazione
		if($('#mdiv_tabledinamic').length){
			var html = 	$('#mdiv_tabledinamic');
			$('#mdiv_tabledinamic').remove();
			$( ".table.clienti-table" ).after(html);
		}
	}
});
function aggiorna_vista(fam_obj, async_mode) {
	// elemento visibile nel viewport
	$(fam_obj).addClass('vis-partial');
	//console.log(current_it);
	
	// carico i vari modelli associato a tale famiglia (?)
	var current_it = $(fam_obj).data('identifier');
	//console.log(current_it);
	var _token = $( "input[name='_token']" ).val();
				
	// costruzioni dati
	dati = {
		'famiglia_id': current_it,
		'_method': 'POST',
		'_token': _token
	};

	// chiamata ajax in post
	$.ajax({
		type: "POST",
		url: '/getviewarticolo',
		async: async_mode,
		data: dati
	}).done(function( data_return ) {
		// visualizzo il risultato
		$(fam_obj).removeClass('vis-partial');
		$(fam_obj).addClass('vis-viewport');
		$(fam_obj).append($(data_return));
		// visualizzo i nuovi articoli 
		$(fam_obj).find('.mod-line > div').each(function( index ) {
			//console.log($(this));
			//$(this).delay(400*index).fadeIn("fast", function(){});
			$(this).fadeIn(300, function(){});
		});
	});
}

function detectPortrait(mainDiv) {
	if (screen.width < screen.height) {
		$(mainDiv).addClass("portrait_mode");
	}
	else {
		$(mainDiv).removeClass("portrait_mode");
	}
};

// versione con filtro che disattiva
/*function active_fltr(value){
	split_arr = value.split("/");
	value =  split_arr[split_arr.length-1];
	//console.log("value:" + value);
	var classe_attiva = ".col-product." + value;
	$(classe_attiva).addClass("no-active"); 
	$( ".no-active" ).fadeOut( "slow", function() {});
}*/
// versione con filtro che attiva
/*function active_fltr(value){
	split_arr = value.split("/");
	value =  split_arr[split_arr.length-1];
	//console.log("value:" + value);
	var classe_attiva = ".col-product." + value;
	$(classe_attiva).not(".active").addClass("active"); 
	$(".col-product.active").fadeIn( "slow", function() {
		mod_fltr_deactive();
	});   
	$(".col-product").not(".active").fadeOut( "slow", function() {
		mod_fltr_deactive();
	});

	all_fltr_deactive();
	//disattiva il loading
	$("#loader").fadeOut(800, function() {});
}*/

// versione con filtro che disattiva
/* function deactive_fltr(value){
	split_arr = value.split("/"); 
	value =  split_arr[split_arr.length-1];
	//console.log("value:" + value);
	var classe_attiva = ".col-product." + value;  
	$(classe_attiva).removeClass("no-active"); 
	$(classe_attiva).fadeIn( "slow", function() {});        
} */
// versione con filtro che attiva
/*function deactive_fltr(value){
	update_fltr();
}*/

// versione con filtro che disattiva
/* function update_fltr(){
	var fltr = $.get( "/filtri/getall", function() { })
	.done(function(data) {
		// scorro elenco dei filtri attivi
		$.each(data, function(i, item) {
			//console.log(item.filtro);                     
			$.each(item.filtro, function(j, item_sec) {                    
				// aggiungo la classe per la colorazione
				var classe_attiva = ".col-product." + item_sec;                    
				// aggiungo la classe non attiva
				$(classe_attiva).addClass("no-active"); 
				$( ".no-active" ).fadeOut( "slow", function() {});
			});
		});
	})
		.fail(function() {
		//alert( "error" );
	})
		.always(function() {
		//alert( "finished" );
	});
} */
// versione con filtro che attiva
function update_fltr(){
	var change_act = false;
	var fltr = $.get( "/filtri/getall", function() { })
	.done(function(data) {
		//console.log($(".col-product.active"));
		$(".col-product.active").removeClass("active");
		//console.log(fltr);
		// scorro elenco dei filtri attivi
		$.each(data, function(i, item) {
			//console.log(item.filtro);                 
			$.each(item.filtro, function(j, item_sec) {   
				//console.log(item_sec);
				if(item_sec != ''){		
					change_act = true;

					// aggiungo la classe per la colorazione
					var classe_attiva = ".col-product." + item_sec;  
					//console.log(classe_attiva);                  
					// aggiungo la classe non attiva
					$(classe_attiva).not(".active").addClass("active"); 
					$(".col-product.active").fadeIn( "slow", function() {}); 
					/*$(".col-product").not(".active").fadeOut( "slow", function() {
						 mod_fltr_deactive();
					});*/
				}
			});
		});

		if(change_act) {
			$(".col-product:visible").not(".active").fadeOut( "slow", function() {
				mod_fltr_deactive();
			});
			all_fltr_deactive();			
		}
	})
	.fail(function() {
		//alert( "error" );
		// scorro elenco dei filtri attivi
	})
	.always(function() {
		//alert( "finished" );
		//disattiva il loading
		//$("#loader").fadeOut(800, function() {});
	});
}
// versione aggiornata del filtro
function update_fltr_estrusione_2 (){
	//visualizzo articoli che non sono ancora stati mostrati
	$('.fam-box-view').not('.vis-viewport, .vis-partial').each(function( index ) {
		var fam_obj = $(this)
		aggiorna_vista(fam_obj, false);
	});

	// pulisco la classe attiva
	$(".col-product").removeClass("active");
	$(".col-product").removeClass("no-active");
	
	var call = "/filtri/getall";		
	var fltr = $.get(call, function() { })
	.done(function(data) {
		// gruppo filtri 
		//console.log(data.length);
		if(data.length > 0){
			var first = true;
			var classe_attiva = ".col-product";
			var filtra_per = "";
			$.each(data, function(i, item) {
				// valore filtro
				$.each(item.filtro, function(j, item_sec) {  
					//console.log(item_sec);
					if(item_sec != ''){		
						// attivo filtro nell'elenco dei filtri
						var classe_attiva_filtri = ".fltr-btn ." + item_sec; 
						$(classe_attiva_filtri).addClass("active");
						if($(".advanced-filters.cls").length){
							$('#toggle-filter').not('.opn').click();
						}

						// creo classe oggetto da attivare
						//var classe_attiva = ".col-product." + item_sec; 
						filtra_per += "." + item_sec;

						// attivo momentaneamente il filtro
						//$(classe_attiva).not(".part-active").addClass("part-active");	

						//di sicurezza
						//$(".col-product").not("." + item_sec).addClass("no-active");						
					}
				});
				//$(".col-product").not("." + item_sec).addClass("no-active");						

				// rendo i filtri parziali definitivi
				/*if ($(".col-product.active").length > 0) {
					// filtri precedenti già attivi
					//$(".col-product.active").not(".part-active").removeClass("active");	
					//$(".col-product.part-active").not(".active").removeClass("part-active");	
					$(".col-product").not(".active.part-active").removeClass("active");	
					//$(".col-product.no-active").removeClass("active");	
					$(".col-product.part-active").removeClass("part-active");
				} else if (first) {
					// senza filtri precedenti attivi
					$(".col-product.part-active").addClass("active");
					//$(".col-product.no-active").removeClass("active");	
					$(".col-product").removeClass("part-active");	
				} else {
					$(".col-product.part-active.active").addClass("active");
					$(".col-product").removeClass("part-active");			
				}*/
			});
			console.log(filtra_per);
			$(classe_attiva).not(filtra_per).removeClass("active");	
			$(classe_attiva + filtra_per).addClass("active");	
			if ($(".col-product.active").length == 0) {
				$(".info-box").fadeIn();
			} else {
				$(".info-box").fadeOut();
			}
		} 
	})
	.fail(function() {
		//console.log("Get filtri errore.");
	})
	.always(function() {
		//console.log($(".col-product.active").length);
		if ($(".col-product.active").length) {
			// nascondo i non attivi
			$(".col-product:visible").not(".active").fadeOut( "slow", function() { });
			// visualizzo gli eventuali attivi ma nascosti
			$(".col-product.active:hidden").fadeIn( "slow", function() { }); 
		} else {			
			$(".col-product:hidden").fadeIn( "slow", function() { });
		}
		update_fltr_fix_view();		
		update_fltr_btn();
	});
}
function update_fltr_estrusione (){
	//visualizzo articoli che non sono ancora stati mostrati
	$('.fam-box-view').not('.vis-viewport, .vis-partial').each(function( index ) {
		var fam_obj = $(this)
		aggiorna_vista(fam_obj, false);
	});

	// pulisco la classe attiva
	$(".col-product").removeClass("active");
	$(".col-product").removeClass("no-active");
	
	var call = "/filtri/getall";		
	var fltr = $.get(call, function() { })
	.done(function(data) {
		// gruppo filtri 
		//console.log(data.length);
		if(data.length > 0){
			var first = true;
			$.each(data, function(i, item) {
				// valore filtro
				$.each(item.filtro, function(j, item_sec) {  
					//console.log(item_sec);
					if(item_sec != ''){		
						// attivo filtro nell'elenco dei filtri
						var classe_attiva_filtri = ".fltr-btn ." + item_sec; 
						$(classe_attiva_filtri).addClass("active");
						if($(".advanced-filters.cls").length){
							$('#toggle-filter').not('.opn').click();
						}

						// creo classe oggetto da attivare
						var classe_attiva = ".col-product." + item_sec; 

						// attivo momentaneamente il filtro
						$(classe_attiva).not(".part-active").addClass("part-active");	

						//di sicurezza
						$(".col-product").not("." + item_sec).addClass("no-active");						
					}
				});
				// rendo i filtri parziali definitivi
				if ($(".col-product.active").length > 0) {
					// filtri precedenti già attivi
					//$(".col-product.active").not(".part-active").removeClass("active");	
					//$(".col-product.part-active").not(".active").removeClass("part-active");	
					$(".col-product").not(".active.part-active").removeClass("active");	
					//$(".col-product.no-active").removeClass("active");	
					$(".col-product.part-active").removeClass("part-active");
				} else if (first) {
					// senza filtri precedenti attivi
					$(".col-product.part-active").addClass("active");
					//$(".col-product.no-active").removeClass("active");	
					$(".col-product").removeClass("part-active");	
				} else {
					$(".col-product.part-active.active").addClass("active");
					$(".col-product").removeClass("part-active");			
				}
			});
			if ($(".col-product.active").length == 0) {
				$(".info-box").fadeIn();
			} else {
				$(".info-box").fadeOut();
			}
		} 
	})
	.fail(function() {
		//console.log("Get filtri errore.");
	})
	.always(function() {
		//console.log($(".col-product.active").length);
		if ($(".col-product.active").length) {
			// nascondo i non attivi
			$(".col-product:visible").not(".active").fadeOut( "slow", function() { });
			// visualizzo gli eventuali attivi ma nascosti
			$(".col-product.active:hidden").fadeIn( "slow", function() { }); 
		} else {			
			$(".col-product:hidden").fadeIn( "slow", function() { });
		}
		update_fltr_fix_view();		
		update_fltr_btn();
	});
}
// fix visuale elementi acontenitore o aggiuntivi
function update_fltr_fix_view (){
	if ($(".col-product.active").length) {
		$(".mod-line").each(function( index ) {
			//console.log($(this).find("div.active").length);
			if($(this).find("div.active").not('.col-header').length < 1){
				$(this).fadeOut( "fast", function() {});
			} else {
				$(this).fadeIn( "fast", function() {});
			}
		});
		$(".coll-box-view").each(function( index ) {
			//console.log($(this).find("div.active").length);
			if($(this).find("div.active").not('.col-header').length < 1){
				$(this).fadeOut( "fast", function() {});
			} else {
				$(this).fadeIn( "fast", function() {});
			}
		});
	} else {
		$(".mod-line").fadeIn( "fast", function() { }); 
		$(".coll-box-view").fadeIn( "fast", function() { }); 
	}
	// disattiva il loading
	//$("#loader").fadeOut(800, function() {});
}
// aggiorno tasti filtri
function update_fltr_btn() {
	if ($(".col-product.active").length) {		
		$(".fltr-btn a").not('.active').each(function( index ) {
			var value = $(this).attr('id');
			value = value.replace("col-","");
			//console.log("value: " + value);
			// orologi con quel valore visibili
			//console.log('.col-product: ' + $('.col-product').length);
			//console.log('.col-product.'+value+': ' + $('.col-product.'+value).length);
			//console.log('.col-product.'+value+':not([style="display:none"]): ' + $('.col-product.'+value+":not([style='display:none'])").length);
			var obj_visible = $('.col-product.'+value+'.active').length;
			//console.log("obj_visible: " + obj_visible);
			if(obj_visible == 0){
				$(this).addClass("link-disable");
			} else {
				$(this).removeClass("link-disable");			
			}			
		});
	} else {		
		if ($('div.products-list.single-collection').length) {
			update_fltr_btn_collection();
		} else {
			$(".fltr-btn a").removeClass("link-disable");			
		}
	}

	// disattiva il loading
	$("#loader").delay(500).fadeOut(500, function() {});
}
function update_fltr_btn_collection() {
	$(".fltr-btn a").not('.active').each(function( index ) {
		var value = $(this).attr('id');
		value = value.replace("col-","");
		var obj_visible = $('.col-product.'+value).length;
		if(obj_visible == 0){
			$(this).addClass("link-disable");
		} else {
			$(this).removeClass("link-disable");			
		}			
	});
}

// visualizzare tutto
function all_fltr_deactive(){
	var elementiattivi = $('.col-product.active').length;
	var bottoniattivi = $('.fltr-btn .active').length;
	if(elementiattivi == 0 && bottoniattivi == 0){
		$(".col-product").fadeIn( "slow", function() { mod_fltr_deactive(); }); 
	}
	if(bottoniattivi > 0) {
		$('#toggle-filter').not('.opn').click();
	}
	//disattiva il loading
	//$("#loader").fadeOut(800, function() {});	
}

// nascondere info modello se tutti gli articoli sono nascosti
function mod_fltr_deactive() {
	$.each($(".mod-line"), function(j, item_sec) {
		var elementi_totali = $(this).find(".col-product").length;
		var elementi_nascosti = $(this).find(".col-product:hidden").length;
		//alert(elementi_totali + " == " + elementi_nascosti);
		if(elementi_totali == elementi_nascosti){
			//alert(elementi_totali + " == " + elementi_nascosti);
			$(this).find(".col-header").fadeOut( "slow", function() {}); 
		} else {
			//alert(elementi_totali + " != " + elementi_nascosti);
			$(this).find(".col-header").fadeIn( "slow", function() {}); 
		}
	});
}
